import styled from '@emotion/styled'

export const QuestionsSectionWrapper = styled.div``
